module.exports = __webpack_public_path__ + "static/media/website-03.bb3fb909.png";